module.exports = __webpack_public_path__ + "img/sb.96acab39.png";